import React, {Component} from 'react'
import {connect} from 'react-redux'
import {app} from "../../../../config/constants";
import {Link} from 'react-router-dom';

class AppCampaignsListComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			campaigns: [],
			showAll: false,
		}

		this.loadCampaigns = this.loadCampaigns.bind(this);
	}

	componentWillMount() {
		this.loadCampaigns();
	}

	componentDidMount() {

	}

	loadCampaigns() {
		app.database().ref('/cams/campaigns').once('value', (campaignsSnap) => {
			let campaigns = [];
			let i = 0;

			new Promise((resolve, reject) => {
				campaignsSnap.forEach((campaign) => {
					campaigns.push({
						data: campaign.val(),
						key : campaign.key
					});

					if (++i === campaignsSnap.numChildren()) {
						resolve(campaigns);
					}
				})

			}).then((campaigns) => {
				this.setState({
					campaigns: campaigns
				})
			})
		});
	}

	archiveCampaign(event, campaign, archived) {
		event.persist();
		event.preventDefault();

		app.database().ref('/cams/campaigns').child(campaign.key).update({
			archived: archived !== true
		}, (error) => {
			this.loadCampaigns();
		})
	}

	showAll() {
		this.setState({
			showAll: this.state.showAll === false
		});
	}

	render() {
		return (
			<div className={'campaigns'}>
				<h1>Campagnes</h1>
				<p onClick={(event) => this.showAll()}>{(this.state.showAll ? 'Verberg gearchiveerde campagnes' : 'Toon alle campagnes')}</p>
				<table>
					<tbody className="campaigns__table">
					{
						this.state.campaigns
							// .sort((a, b) => {
							//
							// 	if (a.data.title < b.data.title) return -1;
							// 	if (a.data.title > b.data.title) return 1;
							// 	return 0;
							//
							// })
							.map((campaign) => {
								const campaignEditLink = 'campaigns/campaign/' + campaign.key;
								const archived = (undefined !== campaign.data.archived && true === campaign.data.archived);

								if ( archived && ! this.state.showAll ) return null;

								return (
									<tr key={campaign.key} className={`campaigns__table__row`}>
										<td>
											<Link to={campaignEditLink}>{campaign.data.title}</Link>
											<div>
												<a href={'#'} onClick={(event) => this.archiveCampaign(event, campaign, archived)}>{(archived ? 'Dearchiveer' : 'Archiveer')}</a>
											</div>
										</td>
									</tr>
								)
							})
					}

					</tbody>
				</table>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {}
};

export default connect(mapStateToProps)(AppCampaignsListComponent)


// WEBPACK FOOTER //
// ./src/application/components/campaigns/components/index.js